module.exports = __webpack_public_path__ + "img/tours_default_image.7fa1ef9.png";